import React from "react";
import ChangeLifecycleButton from "./ChangeLifecycleButton";

interface Props {
  documentId: number
  documentType: server.dto.DocumentTypes
  left?: server.dto.DocumentLifeCycles
  leftValidate?: () => boolean | Promise<boolean>
  leftDisabled?: boolean
  leftOnClick?: () => void
  right?: server.dto.DocumentLifeCycles
  rightValidate?: () => boolean | Promise<boolean>
  rightDisabled?: boolean
  rightOnClick?: () => void
}

const ChangeLifecycleButtons = (props: Props) => {
  return <div className="flex">
    {props.left && <ChangeLifecycleButton
      documentType={props.documentType}
      documentId={props.documentId}
      lifecycle={props.left}
      direction="back"
      disabled={props.leftDisabled}
      validate={props.leftValidate}
      onClick={props.leftOnClick}
    />}
    <div className="grow1"></div>
    {props.right && <ChangeLifecycleButton
      documentType={props.documentType}
      documentId={props.documentId}
      lifecycle={props.right}
      direction="forward"
      disabled={props.rightDisabled}
      validate={props.rightValidate}
      onClick={props.rightOnClick}
    />}
  </div>;
};

export default ChangeLifecycleButtons;